// @ts-nocheck — verbatim port from xop-edge-staff. See src/crm/README.md.
import { Box } from "@mui/material"
import { BulkDeleteDialog } from "@/components/ui/bulk-delete-dialog"

interface Customer {
  id: string | number
  full_name?: string
  company_name?: string
  email?: string
}

interface BulkDeleteCustomerModalProps {
  isOpen: boolean
  onClose: () => void
  selectedCustomers: Customer[]
  onConfirmDelete?: (customerIds: string[]) => Promise<void>
}

export function BulkDeleteCustomerModal({
  isOpen,
  onClose,
  selectedCustomers,
  onConfirmDelete,
}: BulkDeleteCustomerModalProps) {
  return (
    <BulkDeleteDialog
      isOpen={isOpen}
      onClose={onClose}
      items={selectedCustomers}
      entityLabel={{ singular: "Customer", plural: "Customers" }}
      cascadingWarning="This will permanently remove all selected customers from the system. Any associated deals, notes, activities, and files will also be deleted."
      renderItem={(c) => (
        <>
          {c.full_name || c.company_name || `Customer ${c.id}`}
          {c.company_name && c.full_name && (
            <Box component="span" sx={{ color: "error.main" }}> ({c.company_name})</Box>
          )}
        </>
      )}
      onConfirm={async (ids) => {
        if (onConfirmDelete) await onConfirmDelete(ids)
      }}
    />
  )
}
